<template>
  <div class="news-createor-container">
    <a-form-model
      ref="ruleForm"
      :rules="rules"
      :model="spider"
      layout="horizontal"
      :labelCol="{ span: 5 }"
      :wrapperCol="{ span: 18, offset: 1 }"
    >
      <Card title="基础信息">
        <div class="form-container">
          <a-form-model-item label="站点名称" prop="spiderName">
            <a-input v-model="spider.spiderName" placeholder="请输入站点名称" />
          </a-form-model-item>

          <a-form-model-item label="国 家" prop="country">
            <CountrySelect v-model="spider.country" />
          </a-form-model-item>

          <a-form-model-item label="站点地址" prop="spiderUrl">
            <div>
              <ListInput
                style="flex: 1"
                v-model:value="spider.spiderUrl"
                placeholder="请输入站点地址，按回车键或点击加号添加"
                :data-change="spiderUrlsChange"
              />
              <Avatar
                v-if="spider.spiderUrl.length > 0"
                style="margin-left: 10px; max-width: 300px"
                :spiderId="id"
                :address="spider.spiderUrl[0]"
                :type="type"
              />
            </div>
          </a-form-model-item>

          <a-form-model-item label="语 言" prop="lang">
            <LangSelect v-model="spider.lang" />
          </a-form-model-item>

          <a-form-model-item label="部署区域" prop="deployType">
            <a-radio-group v-model="spider.deployType">
              <a-radio :value="0"> 国内</a-radio>
              <a-radio :value="1"> 新加坡</a-radio>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="爬虫深度" prop="spiderLevel">
            <a-select style="width: 100%" v-model="spider.spiderLevel" placeholder="请选择爬取深度">
              <a-select-option :value="-1"> 全部</a-select-option>
              <a-select-option :value="1"> 1层</a-select-option>
              <a-select-option :value="2"> 2层</a-select-option>
              <a-select-option :value="3"> 3层</a-select-option>
              <a-select-option :value="4"> 4层</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="调度周期时间" prop="spiderExecTimeCycle">
            <a-input-group compact>
              <a-input-number
                :min="1"
                :max="max"
                style="width: calc(100% - 95px)"
                v-model="spider.spiderExecTimeCycle"
              >
              </a-input-number>
              <a-select style="width: 95px" v-model="spider.spiderExecTimeType">
                <a-select-option :value="0"> 秒/次</a-select-option>
                <a-select-option :value="1"> 分/次</a-select-option>
                <a-select-option :value="2"> 时/次</a-select-option>
                <a-select-option :value="3"> 天/次</a-select-option>
                <a-select-option :value="4"> 月/次</a-select-option>
              </a-select>
            </a-input-group>
          </a-form-model-item>

          <a-form-model-item label="标签设置" prop="spiderTags">
            <div class="tags-inner">
              <Tag
                class="a-tag"
                v-for="(tag, index) in spider.spiderTags"
                :onDelete="() => onSelectTag(tag)"
                :key="index"
              >
                <a-tooltip :title="tag.spiderTagName" :delay="1000">
                  {{ tag.spiderTagName }}
                </a-tooltip>
              </Tag>
              <div class="add-tag" @click="isShowTagSelectorModal = true">+ 添加标签</div>
            </div>
          </a-form-model-item>

          <a-form-model-item label="解析类型" prop="codeType">
            <a-radio-group v-model="spider.codeType">
              <a-radio value="page"> page</a-radio>
              <a-radio value="api"> api</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </div>
      </Card>

      <Card title="黑白名单配置">
        <div class="form-container">
          <a-form-model-item label="域名(白名单)">
            <TagInput title="域名白名单" v-model="spider.whiteConfig.hosts" />
          </a-form-model-item>

          <a-form-model-item label="域名(黑名单)">
            <TagInput title="域名黑名单" v-model="spider.blackConfig.hosts" />
          </a-form-model-item>

          <a-form-model-item label="路径(白名单)">
            <TagInput title="路径白名单" v-model="spider.whiteConfig.paths" />
          </a-form-model-item>

          <a-form-model-item label="路径(黑名单)">
            <TagInput title="路径黑名单" v-model="spider.blackConfig.paths" />
          </a-form-model-item>
        </div>
      </Card>
      <Card title="高级配置">
        <a-row :gutter="20">
          <a-col :span="6">
            <a-form-model-item label="IP代理">
              <a-radio-group button-style="solid" v-model="spider.ipConfig.enabled">
                <a-radio-button :value="0"> 关 </a-radio-button>
                <a-radio-button :value="1"> 开 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item
              v-if="spider.ipConfig.enabled == 1"
              label="代理国家"
              :prop="Boolean(spider.ipConfig.enabled) ? 'ipConfigCountry' : ''"
            >
              <CountrySelect v-model="spider.ipConfigCountry" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item
              v-if="spider.ipConfig.enabled == 1"
              label="代理数量"
              :prop="Boolean(spider.ipConfig.enabled) ? 'ipConfigNum' : ''"
            >
              <a-input-number
                :min="1"
                v-model="spider.ipConfigNum"
                style="width: 100%"
                placeholder="请输入IP代理数量"
              />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="20">
          <a-col :span="6">
            <a-form-model-item label="并发数">
              <a-input-number
                :min="1"
                style="width: 100%"
                v-model="spider.synNum"
                placeholder="并发数"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="间隔时间(ms)">
              <a-input-number
                :min="1"
                style="width: 100%"
                v-model="spider.synCycle"
                placeholder="间隔时间"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="重试次数">
              <a-input-number
                :min="1"
                style="width: 100%"
                v-model="spider.retryNum"
                placeholder="重试次数"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="超时时间(ms)">
              <a-input-number
                :min="1"
                style="width: 100%"
                v-model="spider.timeOut"
                placeholder="请求超时时间"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-button size="large" class="btn" type="primary" @click="onSubmit">下一步</a-button>
        <a-button
          size="large"
          class="btn"
          style="bottom: 50px"
          type="primary"
          v-if="id"
          @click="back()"
          >返回</a-button
        >
      </Card>
    </a-form-model>

    <a-modal
      title="选择标签"
      :visible="isShowTagSelectorModal"
      okText="确定"
      cancelText="取消"
      :closable="false"
      @cancel="isShowTagSelectorModal = false"
      @ok="isShowTagSelectorModal = false"
      :width="725"
    >
      <div class="tags-modal-contianer">
        <Tag
          v-for="(tag, index) in labels"
          :key="index"
          :isActive="spider.spiderTags.map((t) => t.spiderTagId).includes(tag.spiderTagId)"
          :onSelect="() => onSelectTag(tag)"
          :canDelete="false"
        >
          <a-tooltip :title="tag.spiderTagName" :delay="1000">
            {{ tag.spiderTagName }}
          </a-tooltip>
        </Tag>
      </div>
    </a-modal>
  </div>
</template>

<script>
import ListInput from '@/components/ListInput/'
import LangSelect from '@/components/LangSelect/'
import CountrySelect from '@/components/CountrySelect/'
import Avatar from '@/components/Avatar/'
import { queryTagListApi } from '@/api/Site/Create'

import { onHttpResponseSilent } from '@/utils/request'
import Tag from '../components/Tag'
import Card from '../components/Card'
import TagInput from '../components/TagInput'

export default {
  components: {
    ListInput,
    Avatar,
    LangSelect,
    CountrySelect,
    Card,
    Tag,
    TagInput
  },
  props: ['spider', 'id', 'type'],
  data() {
    let validateSpiderUrls = (rule, value, callback) => {
      if (value == null || value.length == 0) {
        callback(new Error('站点地址至少填写一个'))
      } else {
        callback()
      }
    }
    return {
      activeKey: [1, 2],
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      min: 1,
      rules: {
        spiderName: [{ required: true, message: '站点名称必填', trigger: 'blur' }],
        deployType: [{ required: true, message: '部署方式必填', trigger: 'blur' }],
        codeType: [{ required: true, message: '解析类型必填', trigger: 'blur' }],
        country: [{ required: true, message: '国家必填', trigger: 'blur' }],
        spiderLevel: [{ required: true, message: '爬取深度必填', trigger: 'blur' }],
        ipConfigNum: [{ required: true, message: '代理数量必填', trigger: 'blur' }],
        ipConfigCountry: [{ required: true, message: '代理国家必填', trigger: 'blur' }],
        spiderUrl: [
          {
            required: true,
            type: 'array',
            validator: validateSpiderUrls,
            trigger: 'change'
          }
        ],
        lang: [{ required: true, message: '国家必填', trigger: 'blur' }],
        spiderTags: [
          {
            type: 'array',
            required: true,
            message: '标签至少选择一个',
            trigger: 'change'
          }
        ]
      },

      isShowTagSelectorModal: false,
      labels: []
    }
  },
  computed: {
    max() {
      let { spiderExecTimeType } = this.spider
      if (spiderExecTimeType == 0 || spiderExecTimeType == 1) {
        return 59
      } else if (spiderExecTimeType == 2) {
        return 23
      } else if (spiderExecTimeType == 3) {
        return 31
      } else {
        return 12
      }
    }
  },
  mounted() {
    this.getLabels()
  },
  methods: {
    back() {
      // sessionStorage.types = 'others'
      // this.$router.back(-1)
      this.$emit('back')
    },
    spiderUrlsChange(spiderUrl) {
      this.$refs.ruleForm.validateField('spiderUrl')
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('changeActive')
        } else {
          this.$message.error('表单填写不完整，请检查表单')
        }
      })
    },
    getLabels() {
      queryTagListApi({

      })
        .then(onHttpResponseSilent)
        .then(({ data }) => {
          this.labels = data
        })
    },
    onSelectTag(tag) {
      if (this.spider.spiderTags.map((t) => t.spiderTagId).includes(tag.spiderTagId)) {
        this.spider.spiderTags = this.spider.spiderTags.filter(
          (t) => t.spiderTagId !== tag.spiderTagId
        )
      } else {
        this.spider.spiderTags.push(tag)
      }

      this.$refs.ruleForm.validateField('spiderTags')
    }
  }
}
</script>

<style lang="less" scoped>
.news-createor-container {
  /*margin-bottom: 50px;*/

  .form-container {
    width: 100%;
    display: grid;
    grid-template-columns: 45% 45%;
    gap: 0 60px;

    &.tiny {
      grid-template-columns: repeat(auto-fill, 280px);
    }

    .tags-inner {
      display: grid;
      grid-template-columns: repeat(auto-fill, 86px);
      gap: 10px;

      .a-tag:hover {
        background: #3c93ff;
        color: #fff;
      }

      .add-tag {
        width: 100%;
        height: 36px;
        background: #f5f6fa;
        border-radius: 4px;
        color: #3c93ff;
        border: none;
        line-height: 34px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}

.tags-modal-contianer {
  display: grid;
  grid-template-columns: repeat(auto-fill, 88px);
  gap: 10px;
}

.btn {
  position: absolute;
  bottom: 0px;
  right: -180px;
  width: 100px;
}
</style>
